import { ICartItemForFixCart } from "@faire/retailer-visitor-shared/stores/domain/CartStore/fixCart";
export var createCartItemForFixCart = function(item) {
    var _item_customizations, _item_issues;
    return ICartItemForFixCart.build({
        token: item.token,
        product_token: item.product_token,
        product_option_token: item.product_option_token,
        customizations: (_item_customizations = item.customizations) !== null && _item_customizations !== void 0 ? _item_customizations : [],
        quantity: item.quantity,
        cart_item_issues: (_item_issues = item.issues) !== null && _item_issues !== void 0 ? _item_issues : []
    });
};
